interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
        <i className={`${icon} text-2xl`}></i>
      </span>
      <h3 className="font-heading text-lg font-semibold text-foreground-900">{title}</h3>
      {description && (
        <p className="max-w-md text-sm text-foreground-600">{description}</p>
      )}
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-2 inline-flex items-center gap-1 rounded-md bg-primary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-refresh-line text-base"></i>
          </span>
          {actionLabel}
        </button>
      )}
    </div>
  );
}